import { PageStateInterface, PageStore } from '@/page/infrastructure/store/PageStore';
import { usePlocState } from '@hfc/ui-core';
import { inject, provide } from 'vue';

export function usePageStore (): { pageState: ReturnType<typeof usePlocState<PageStateInterface>>, pageStore: PageStore } {
  let pageStore = inject<PageStore | null>('PageStore') as PageStore;

  if (!pageStore) {
    pageStore = new PageStore();
    provide('PageStore', pageStore);
  }

  const pageState = usePlocState(pageStore);

  return {
    pageState,
    pageStore
  };
}
